var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenaamSvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 32,
    viewBox: "0 0 49 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 32,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Section 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1303 -5835C-1303 -5836.1 -1302.1 -5837 -1301 -5837H2583C2584.1 -5837 2585 -5836.1 2585 -5835V1512C2585 1513.1 2584.1 1514 2583 1514H-1301C-1302.1 1514 -1303 1513.1 -1303 1512V-5835Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Desktop - 11",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5188,
    transform: "translate(-136 -4911)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427318977"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 203",
    x: -136,
    y: -92,
    width: 1440,
    height: 369,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427318976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Benaam - SVG Logo 1",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M48.9995 2.43457H45.5488V5.91283H48.9995V2.43457Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M23.8101 10.0869H20.3594V13.5652H23.8101V10.0869Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1",
    d: "M0 8.34783V2.78261H38.6479V0H44.169V8.34783H0Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M38.6479 23.6523V26.435H0V32.0002H44.169V23.6523H38.6479Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    d: "M38.6479 11.8262V14.6088H5.52113V11.8262H0V20.174H44.169V11.8262H38.6479Z",
    fill: "#0D0D0D"
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "M-1301 -5836H2583V-5838H-1301V-5836ZM2584 -5835V1512H2586V-5835H2584ZM2583 1513H-1301V1515H2583V1513ZM-1302 1512V-5835H-1304V1512H-1302ZM-1301 1513C-1301.55 1513 -1302 1512.55 -1302 1512H-1304C-1304 1513.66 -1302.66 1515 -1301 1515V1513ZM2584 1512C2584 1512.55 2583.55 1513 2583 1513V1515C2584.66 1515 2586 1513.66 2586 1512H2584ZM2583 -5836C2583.55 -5836 2584 -5835.55 2584 -5835H2586C2586 -5836.66 2584.66 -5838 2583 -5838V-5836ZM-1301 -5838C-1302.66 -5838 -1304 -5836.66 -1304 -5835H-1302C-1302 -5835.55 -1301.55 -5836 -1301 -5836V-5838Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5188,
    fill: "white",
    transform: "translate(-136 -4911)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenaamSvgLogo1);
export default __webpack_public_path__ + "static/media/benaam-svg-logo-1.ff7917e25a67e3d78ee1d67789c56c21.svg";
export { ForwardRef as ReactComponent };